// extracted by mini-css-extract-plugin
module.exports = {"TableFooter":"DealTable_TableFooter__sMIMK","PaginationContainer":"DealTable_PaginationContainer__zJn9I","PC":"DealTable_PC__wTV_y","SP":"DealTable_SP__J64Ec"};